import set from "lodash/set";
import unset from "lodash/unset";
import type { Action } from "../../actions/types";

export type StoreState = {
  [key: string]: { [index: string]: any };
};

export const initialState: StoreState = {};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "SET_WIDGET_FORM_ERROR":
      const { path, errorMessage } = action.data;

      // if error message is define an error is recorded
      if (errorMessage) {
        return set({ ...state }, path, errorMessage);
      } else {
        // otherwise the error is removed
        const newState = { ...state };
        unset(newState, path);

        return newState;
      }

    case "CLEAR_WIDGET_FORM_ERROR": {
      const { path } = action;

      const newState = { ...state };
      unset(newState, path);

      return newState;
    }

    case "CLEAR_WIDGET_FORM_ERRORS":
    case "RESET_WIDGET_STATE":
      return { ...initialState };

    default:
      return state;
  }
}
